// extracted by mini-css-extract-plugin
module.exports = {"main_content":"Layout_main_content__EnlhF"};